import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IpcFeatureToggleDirective } from './feature-toggle.directive';
import { IpcFeatureToggleService } from './feature-toggle.service';
import { IpcFeatureToggleConfiguration } from './feature-toggle.configuration';

@NgModule({
    imports: [CommonModule],
    declarations: [IpcFeatureToggleDirective],
    exports: [IpcFeatureToggleDirective],
    providers: [IpcFeatureToggleService]
})
// export class RolloutModule {
//     static forRoot(configuration: RolloutConfiguration): ModuleWithProviders {
//         return {
//             ngModule: RolloutModule,
//             providers: [
//                 RolloutService,
//                 {
//                     provide: 'ROLLOUT_CONFIGURATION',
//                     useValue: configuration
//                 }
//             ]
//         }
//     }
// }
export class IpcFeatureToggleModule {
    constructor() { }
    // static forRoot(): ModuleWithProviders {
    //     return {
    //         ngModule: RolloutModule,
    //         providers: [RolloutService]
    //     };
    // }
}
